/**
 * MenoQueen Quiz — Alpine.js component
 * Lightweight component-based UI (~15KB Alpine, no build).
 * WITH PERSISTENT STATE & EMAIL LINK RESTORATION & URL TRACKING & FACEBOOK LEAD EVENT
 */

(function () {
  'use strict';

  // ============================================
  // STORAGE KEYS - NOW USING LOCALSTORAGE
  // ============================================
  var STORAGE_ANSWERS = 'menoqueen_quiz_answers_persistent';
  var STORAGE_STEP = 'menoqueen_quiz_step_persistent';
  var STORAGE_TIMER_END = 'menoqueen_timer_end';
  var STORAGE_QUIZ_ID = 'menoqueen_quiz_id';
  var STORAGE_EMAIL = 'menoqueen_quiz_email';
  var TIMER_DURATION = 24 * 60 * 60; // 24 hours in seconds

  // ============================================
  // PERSISTENT STATE & EMAIL LINK HELPERS
  // ============================================

  // Generate unique quiz session ID
  function generateQuizId() {
    return 'quiz_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // Get or create quiz ID
  function getQuizId() {
    var quizId = localStorage.getItem(STORAGE_QUIZ_ID);
    if (!quizId) {
      quizId = generateQuizId();
      localStorage.setItem(STORAGE_QUIZ_ID, quizId);
    }
    return quizId;
  }

  // Encode quiz state to URL-safe string
  function encodeQuizState(answers, step, email) {
    var state = {
      a: answers,
      s: step,
      e: email || null,
      id: getQuizId()
    };
    return btoa(JSON.stringify(state)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  // Decode quiz state from URL parameter
  function decodeQuizState(stateParam) {
    try {
      var normalized = stateParam.replace(/-/g, '+').replace(/_/g, '/');
      var decoded = atob(normalized);
      return JSON.parse(decoded);
    } catch (e) {
      return null;
    }
  }

  // Get URL parameters
  function getUrlParams() {
    var params = {};
    var queryString = window.location.search.substring(1);
    var pairs = queryString.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      if (pair[0]) {
        params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
      }
    }
    return params;
  }

  /** Normalize config to steps array. Supports: (1) steps[] with stepType, (2) legacy questions[] → steps with stepType 'question'. */
  function normalizeToSteps(config) {
    if (config.steps && Array.isArray(config.steps) && config.steps.length > 0) {
      return config.steps;
    }
    var questions = config.questions || [];
    return questions.map(function (q) {
      return Object.assign({ stepType: 'question' }, q);
    });
  }

  function quizApp() {
    return {
      steps: [],
      step: 0,
      answers: {},
      _autoAdvanceTimer: null,
      _stepAnimationTimers: [],
      _bannerTimerInterval: null,
      bannerTimerSeconds: TIMER_DURATION - 1,

      get total() {
        return this.steps.length;
      },

      get currentStep() {
        return this.steps[this.step] || null;
      },

      get currentQuestion() {
        var s = this.currentStep;
        return s && s.stepType === 'question' ? s : null;
      },

      get answeredCount() {
        var self = this;
        return this.steps.filter(function (s) {
          return self.isStepComplete(s);
        }).length;
      },

      get progressPct() {
        if (this.total === 0) return 0;
        if (this.step === 0) return 0;
        if (this.total === 1) return 100;
        return Math.round((this.step / (this.total - 1)) * 100);
      },

      get resultsSteps() {
        return this.steps.filter(function (s) {
          return s.layout === 'results';
        });
      },

      get resultsTotal() {
        return this.resultsSteps.length;
      },

      get currentResultIndex() {
        var currentId = this.currentStep ? this.currentStep.id : null;
        if (!currentId) return 0;
        for (var i = 0; i < this.resultsSteps.length; i++) {
          if (this.resultsSteps[i].id === currentId) {
            return i + 1;
          }
        }
        return 0;
      },

      get resultsSegments() {
        var segments = [];
        var currentIdx = this.currentResultIndex;
        for (var i = 1; i <= this.resultsTotal; i++) {
          segments.push({
            index: i,
            filled: i <= currentIdx
          });
        }
        return segments;
      },

      get bannerTimerDisplay() {
        var total = this.bannerTimerSeconds;
        if (total < 0) total = 0;
        var hours = Math.floor(total / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        return (hours < 10 ? '0' : '') + hours + ':' +
               (minutes < 10 ? '0' : '') + minutes + ':' +
               (seconds < 10 ? '0' : '') + seconds;
      },

      startBannerTimer: function () {
        var self = this;
        var storedEnd = localStorage.getItem(STORAGE_TIMER_END);
        var now = Math.floor(Date.now() / 1000);
        var endTime;

        if (storedEnd) {
          endTime = parseInt(storedEnd, 10);
          if (endTime <= now) {
            endTime = now + TIMER_DURATION;
            localStorage.setItem(STORAGE_TIMER_END, endTime.toString());
          }
        } else {
          endTime = now + TIMER_DURATION;
          localStorage.setItem(STORAGE_TIMER_END, endTime.toString());
        }

        this.bannerTimerSeconds = Math.max(0, endTime - now - 1);

        if (this._bannerTimerInterval) {
          clearInterval(this._bannerTimerInterval);
        }

        this._bannerTimerInterval = setInterval(function () {
          var currentNow = Math.floor(Date.now() / 1000);
          var remaining = endTime - currentNow;

          if (remaining <= 0) {
            endTime = currentNow + TIMER_DURATION;
            localStorage.setItem(STORAGE_TIMER_END, endTime.toString());
            remaining = TIMER_DURATION - 1;
          }

          self.bannerTimerSeconds = remaining;
        }, 1000);
      },

      setupTimerResponsive: function () {
        var timer = document.querySelector('.promotion-timer');
        var titleWrap = document.querySelector('.promotion-title-wrap');
        var content = document.querySelector('.promotion-content');
        if (!timer || !titleWrap || !content) return;

        var breakpoint = 936;

        function moveTimer() {
          var isMobile = window.innerWidth < breakpoint;
          if (isMobile && timer.parentElement !== titleWrap) {
            titleWrap.appendChild(timer);
          } else if (!isMobile && timer.parentElement !== content) {
            content.appendChild(timer);
          }
        }

        moveTimer();
        window.addEventListener('resize', moveTimer);
      },

      init: function () {
        this.loadState();
        this.startBannerTimer();
        this.setupTimerResponsive();
        var self = this;
        
        var questionsUrl = window.MENOQUEEN_QUESTIONS_URL || null;
        if (questionsUrl) {
          fetch(questionsUrl)
            .then(function (r) { return r.json(); })
            .then(function (json) {
              self.steps = normalizeToSteps(json);
              self.resolveSavedStep();
              self.normalizeStep();
              self.persist();
              setTimeout(function () { 
                self.handleAutoAdvance();
                // Update URL after data loads
                if (self.steps && self.steps.length > 0) {
                  self.updateUrlWithStep();
                }
              }, 100);
            })
            .catch(function () {
              self.steps = normalizeToSteps(STEPS_FALLBACK);
              self.resolveSavedStep();
              self.normalizeStep();
              self.persist();
              setTimeout(function () { 
                self.handleAutoAdvance();
                // Update URL after data loads
                if (self.steps && self.steps.length > 0) {
                  self.updateUrlWithStep();
                }
              }, 100);
            });
        } else {
          self.steps = normalizeToSteps(STEPS_FALLBACK);
          self.resolveSavedStep();
          self.normalizeStep();
          self.persist();
          setTimeout(function () { 
            self.handleAutoAdvance();
            // Update URL after data loads
            if (self.steps && self.steps.length > 0) {
              self.updateUrlWithStep();
            }
          }, 100);
        }

        document.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-quiz-action]');
          if (!btn) return;
          var action = btn.getAttribute('data-quiz-action');
          if (action === 'next') self.next();
          else if (action === 'back') self.back();
        });
      },

      loadState: function () {
        var urlParams = getUrlParams();
        
        if (urlParams.state) {
          var decoded = decodeQuizState(urlParams.state);
          if (decoded) {
            this.answers = decoded.a || {};
            this.step = decoded.s || 0;
            
            localStorage.setItem(STORAGE_ANSWERS, JSON.stringify(this.answers));
            localStorage.setItem(STORAGE_STEP, this.step.toString());
            
            if (decoded.e) {
              localStorage.setItem(STORAGE_EMAIL, decoded.e);
            }
            
            if (urlParams.coupon) {
              this.applyCoupon(urlParams.coupon);
            }
            
            return;
          }
        }
        
        try {
          var savedStep = localStorage.getItem(STORAGE_STEP);
          if (savedStep !== null) {
            var n = parseInt(savedStep, 10);
            if (!isNaN(n) && n >= 0) {
              this.step = n;
            } else {
              this._savedStepId = savedStep;
            }
          }
          
          var savedAnswers = localStorage.getItem(STORAGE_ANSWERS);
          if (savedAnswers) {
            this.answers = JSON.parse(savedAnswers);
            if (typeof this.answers !== 'object' || this.answers === null) this.answers = {};
          }
        } catch (_) {
          this.answers = {};
        }
      },

      resolveSavedStep: function () {
        if (this._savedStepId && this.steps.length > 0) {
          for (var i = 0; i < this.steps.length; i++) {
            if (this.steps[i].id === this._savedStepId) {
              this.step = i;
              break;
            }
          }
          this._savedStepId = null;
        }
      },

      normalizeStep: function () {
        if (this.step >= this.total) this.step = Math.max(0, this.total - 1);
      },

      isStepComplete: function (s) {
        if (!s || !s.id) return false;
        var v = this.answers[s.id];
        if (s.stepType === 'question') {
          if (s.type === 'multiple') return Array.isArray(v) && v.length > 0;
          if (s.type === 'single') return v != null && String(v).trim() !== '';
          return v !== undefined && v !== null && v !== '';
        }
        if (s.stepType === 'static' || s.stepType === 'calculating') return true;
        if (s.stepType === 'email_capture') return v && v.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v.email).trim());
        if (s.stepType === 'product_select') return v && (v.productId || v.product);
        return true;
      },

      get isCurrentStepComplete() {
        return this.isStepComplete(this.currentStep);
      },

      get isCurrentStepRequired() {
        var s = this.currentStep;
        return s && s.required !== false;
      },

      persist: function () {
        try {
          var stepId = this.currentStep ? this.currentStep.id : (this.steps[0] ? this.steps[0].id : '');
          localStorage.setItem(STORAGE_STEP, stepId);
          localStorage.setItem(STORAGE_ANSWERS, JSON.stringify(this.answers));
        } catch (_) {}
      },

      /** Update URL query string with current step for analytics tracking */
      updateUrlWithStep: function () {
        // Safety checks - don't run if quiz isn't fully initialized
        if (!this.steps || this.steps.length === 0) return;
        if (this.step < 0 || this.step >= this.steps.length) return;
        
        var currentStep = this.currentStep;
        if (!currentStep || !currentStep.id) return;

        try {
          // Build URL manually to avoid compatibility issues
          var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
          var params = [];
          
          // Add step parameter
          params.push('step=' + encodeURIComponent(currentStep.id));
          
          // Preserve existing state and coupon parameters
          var urlParams = getUrlParams();
          if (urlParams.state) {
            params.push('state=' + encodeURIComponent(urlParams.state));
          }
          if (urlParams.coupon) {
            params.push('coupon=' + encodeURIComponent(urlParams.coupon));
          }
          
          // Construct new URL
          var newUrl = baseUrl + (params.length > 0 ? '?' + params.join('&') : '');
          
          // Update browser URL without reload
          window.history.pushState({}, '', newUrl);
        } catch (e) {
          // Silent fail - don't break quiz if URL API fails
          console.warn('Could not update URL:', e);
        }
      },

      handleEmailInput: function (event, stepId) {
        this.setStepAnswer(stepId, { email: event.target.value });
      },

      isEmailValid: function (stepId) {
        var answer = this.getStepAnswer(stepId);
        if (!answer || !answer.email) return false;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(answer.email).trim());
      },

      submitEmailCapture: function (stepId) {
        if (this.isEmailValid(stepId)) {
          var answer = this.getStepAnswer(stepId);
          var email = answer.email.trim();
          this.sendToKlaviyo(email);
          this.next();
        }
      },

      sendToKlaviyo: function (email) {
        var self = this;
        localStorage.setItem(STORAGE_EMAIL, email);
        
        // ============================================
        // FACEBOOK LEAD EVENT
        // ============================================
        this.trackFacebookLead(email);
        
        var nextStepIndex = this.step + 1;
        var nextStepId = (this.steps[nextStepIndex] && this.steps[nextStepIndex].id) ? this.steps[nextStepIndex].id : 'result-1';
        var stateParam = encodeQuizState(this.answers, nextStepIndex, email);
        var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        var quizStateUrl = baseUrl + '?state=' + stateParam;
        
        var customProperties = {
          'Quiz Completed': false,
          'quiz_completed_at': '',
          'quiz_source': 'menoqueen_quiz',
          'quiz_state_url': quizStateUrl,
          'quiz_current_step': nextStepId
        };
        
        var answerKeys = Object.keys(this.answers);
        for (var i = 0; i < answerKeys.length; i++) {
          var stepId = answerKeys[i];
          var answer = self.answers[stepId];
          if (answer !== null && answer !== undefined) {
            if (typeof answer === 'object' && answer.email) {
              // Skip
            } else if (Array.isArray(answer)) {
              customProperties['quiz_' + stepId] = answer.join(', ');
            } else if (typeof answer === 'object') {
              customProperties['quiz_' + stepId] = JSON.stringify(answer);
            } else {
              customProperties['quiz_' + stepId] = String(answer);
            }
          }
        }
        
        if (typeof _learnq !== 'undefined') {
          var identifyData = { '$email': email };
          for (var key in customProperties) {
            identifyData[key] = customProperties[key];
          }
          _learnq.push(['identify', identifyData]);
          _learnq.push(['track', 'Quiz Started', customProperties]);
          console.log('Email identified in Klaviyo:', email);
        }
        
        this.subscribeToKlaviyoList(email, customProperties);
      },

      /** Track Facebook Lead event for ads optimization */
      trackFacebookLead: function (email) {
        // Check if Facebook Pixel is loaded
        if (typeof fbq === 'undefined') {
          console.warn('Facebook Pixel not loaded');
          return;
        }
        
        try {
          // Fire the Lead event
          fbq('track', 'Lead', {
            content_name: 'MenoQueen Quiz',
            content_category: 'Lead Generation'
          }, {
            eventID: this.getFacebookEventId(),
            userData: { em: email }
          });
          
          console.log('Facebook Lead event fired for:', email);
        } catch (e) {
          console.error('Facebook tracking error:', e);
        }
      },

      /** Generate unique event ID to prevent duplicates */
      getFacebookEventId: function () {
        var quizId = getQuizId();
        var email = localStorage.getItem(STORAGE_EMAIL) || '';
        return 'quiz_lead_' + quizId + '_' + btoa(email).substring(0, 10);
      },

      subscribeToKlaviyoList: function (email, customProperties) {
        var listId = window.KLAVIYO_LIST_ID || null;
        var companyId = window.KLAVIYO_COMPANY_ID || null;
        
        if (!companyId && typeof klaviyo !== 'undefined' && klaviyo.account) {
          companyId = klaviyo.account;
        }
        
        if (!listId) {
          console.warn('Klaviyo List ID not configured. Set window.KLAVIYO_LIST_ID');
          return;
        }
        
        if (!companyId) {
          console.warn('Klaviyo Company ID not found. Set window.KLAVIYO_COMPANY_ID');
          return;
        }
        
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'MenoQueen Quiz',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: customProperties
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };
        
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify(payload)
        })
        .then(function (response) {
          if (response.ok || response.status === 202) {
            console.log('Successfully subscribed to Klaviyo list:', email);
          } else {
            console.error('Klaviyo list subscription failed:', response.status);
            response.text().then(function(text) {
              console.error('Klaviyo response:', text);
            });
          }
        })
        .catch(function (error) {
          console.error('Klaviyo subscription error:', error);
        });
      },

      markQuizComplete: function () {
        var email = localStorage.getItem(STORAGE_EMAIL);
        if (!email) return;
        
        var completedProperties = {
          'Quiz Completed': true,
          'quiz_completed_at': new Date().toISOString()
        };
        
        if (typeof _learnq !== 'undefined') {
          var identifyData = { '$email': email };
          for (var key in completedProperties) {
            identifyData[key] = completedProperties[key];
          }
          _learnq.push(['identify', identifyData]);
          _learnq.push(['track', 'Quiz Completed', completedProperties]);
          console.log('Quiz marked complete in Klaviyo');
        }
      },

      clearShopifyCart: function () {
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(function () {
          console.log('Shopify cart cleared');
        })
        .catch(function (err) {
          console.warn('Cart clear failed:', err);
        });
      },

      updateCurrentStep: function () {
        var email = localStorage.getItem(STORAGE_EMAIL);
        if (!email) return;
        
        var currentStep = this.currentStep ? this.currentStep.id : '';
        var stateParam = encodeQuizState(this.answers, this.step, email);
        var baseUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
        var quizStateUrl = baseUrl + '?state=' + stateParam;
        
        var updateProperties = {
          'quiz_current_step': currentStep,
          'quiz_state_url': quizStateUrl
        };
        
        if (typeof _learnq !== 'undefined') {
          var identifyData = { '$email': email };
          for (var key in updateProperties) {
            identifyData[key] = updateProperties[key];
          }
          _learnq.push(['identify', identifyData]);
        }
      },

      applyCoupon: function (couponCode) {
        localStorage.setItem('menoqueen_coupon', couponCode);
        console.log('Coupon applied:', couponCode);
      },

      clearAutoAdvance: function () {
        if (this._autoAdvanceTimer) {
          clearTimeout(this._autoAdvanceTimer);
          this._autoAdvanceTimer = null;
        }
        this._stepAnimationTimers.forEach(function (t) { clearTimeout(t); });
        this._stepAnimationTimers = [];
      },

      handleAutoAdvance: function () {
        var self = this;
        this.clearAutoAdvance();

        var s = this.currentStep;
        if (!s) return;

        // 🔥 CLEAR CART ON EVERY ENTRY + EVERY RELOAD
        if (s.id === 'product-recommendation') {
          this.clearShopifyCart();
        }

        if (s.id === 'preparing-summary') {
          this.animateLoadingSteps();
        }

        if (s.autoAdvance && typeof s.autoAdvance === 'number' && s.autoAdvance > 0) {
          this._autoAdvanceTimer = setTimeout(function () {
            self.next();
          }, s.autoAdvance);
        }
      },

      animateLoadingSteps: function () {
        var self = this;
        var stepCount = 4;
        var stepDuration = 1250;

        setTimeout(function () {
          for (var i = 1; i <= stepCount; i++) {
            (function (index) {
              var activateTimer = setTimeout(function () {
                var stepEl = document.querySelector('.ps-step-' + index);
                if (stepEl) {
                  stepEl.classList.add('ps-active');
                }
              }, (index - 1) * stepDuration);
              self._stepAnimationTimers.push(activateTimer);

              var doneTimer = setTimeout(function () {
                var stepEl = document.querySelector('.ps-step-' + index);
                if (stepEl) {
                  stepEl.classList.remove('ps-active');
                  stepEl.classList.add('ps-done');
                }
              }, index * stepDuration);
              self._stepAnimationTimers.push(doneTimer);
            })(i);
          }
        }, 200);
      },

      hasCurrentAnswer: function () {
        return this.isCurrentStepComplete;
      },

      isCurrentRequired: function () {
        return this.isCurrentStepRequired;
      },

      setStepAnswer: function (stepId, value) {
        this.answers[stepId] = value;
        this.persist();
      },

      getStepAnswer: function (stepId) {
        return this.answers[stepId];
      },

      next: function () {
        var self = this;
        this.clearAutoAdvance();
        
        if (this.step < this.total - 1) {
          this.step += 1;
          
          var currentStep = this.currentStep;
          if (currentStep && currentStep.id === 'product-recommendation') {       
            this.markQuizComplete();
          }
          
          this.updateCurrentStep();
          this.persist();
          this.updateUrlWithStep();
          setTimeout(function () { self.handleAutoAdvance(); }, 100);
        }
      },

      back: function () {
        var self = this;
        this.clearAutoAdvance();
        if (this.step > 0) {
          this.step -= 1;
          this.updateCurrentStep();
          this.persist();
          this.updateUrlWithStep();
          setTimeout(function () { self.handleAutoAdvance(); }, 100);
        }
      },

      getCurrentAnswer: function (option) {
        var q = this.currentQuestion;
        if (!q) return q.type === 'multiple' ? [] : '';
        var v = this.answers[q.id];
        var val = option.value !== undefined ? option.value : option.id;
        if (q.type === 'multiple') {
          var arr = Array.isArray(v) ? v : [];
          return arr.indexOf(val) >= 0;
        }
        return v === val;
      },

      isSelected: function (option) {
        return this.getCurrentAnswer(option);
      },

      setAnswer: function (option) {
        var q = this.currentQuestion;
        if (!q) return;
        var val = option.value !== undefined ? option.value : option.id;
        this.answers[q.id] = val;
        this.persist();
      },

      toggleAnswer: function (option) {
        var q = this.currentQuestion;
        if (!q || q.type !== 'multiple') return;
        var val = option.value !== undefined ? option.value : option.id;
        var arr = Array.isArray(this.answers[q.id]) ? this.answers[q.id].slice() : [];
        var i = arr.indexOf(val);
        if (i >= 0) arr.splice(i, 1);
        else arr.push(val);
        this.answers[q.id] = arr;
        this.persist();
      },

      getPurchaseType: function (stepId) {
        var answer = this.answers[stepId];
        if (answer && answer.purchaseType) {
          return answer.purchaseType;
        }
        return 'subscription';
      },

      setPurchaseType: function (stepId, type) {
        var answer = this.answers[stepId] || {};
        answer.purchaseType = type;
        this.answers[stepId] = answer;
        this.persist();
      },

      getProductPrice: function (stepId, productId, priceType) {
        var purchaseType = this.getPurchaseType(stepId);
        var step = this.currentStep;
        if (!step || !step.products) return '0.00';
        
        var product = null;
        for (var i = 0; i < step.products.length; i++) {
          if (step.products[i].id === productId) {
            product = step.products[i];
            break;
          }
        }
        if (!product) return '0.00';

        var prices = purchaseType === 'subscription' ? product.subscriptionPrices : product.onetimePrices;
        if (!prices) return '0.00';

        if (priceType === 'perBottle') {
          return prices.perBottle.toFixed(2);
        } else if (priceType === 'total') {
          return prices.total.toFixed(2);
        } else if (priceType === 'save') {
          return prices.save.toFixed(2);
        }
        return '0.00';
      },

      getAddToCartUrl: function (step, product) {
        var purchaseType = this.getPurchaseType(step.id);
        var variantId = product.variantId;
        var url = '/cart/add?id=' + variantId + '&quantity=1';
        
        if (purchaseType === 'subscription' && product.sellingPlanId) {
          url += '&selling_plan=' + product.sellingPlanId;
        }
        
        var coupon = localStorage.getItem('menoqueen_coupon');
        if (coupon) {
          url += '&discount=' + coupon;
        }
        
        url += '&return_to=/checkout';
        
        return url;
      }
    };
  }

  document.addEventListener('alpine:init', function () {
    window.Alpine.data('quizApp', quizApp);
  });
})();